import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';

/**
 * Campaign content-sections carousel (Green) — Türkis Design System.
 *
 * Renders `plp_content.content_sections` as swipeable slides (image + heading +
 * body + CTA), the carousel presentation of legacy repeated feature blocks
 * (e.g. acrilico "Cosa rende…", mappa "Il regalo"). Mirrors image-slider's
 * Swiper wiring; no per-slide caption/video handling. NGE-7761.
 */
class CampaignSectionsCarousel extends HTMLElement {
  connectedCallback() {
    this.#initSwiper();
  }

  disconnectedCallback() {
    this.swiper?.destroy?.(true, true);
  }

  #initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;

    const paginationEl = this.querySelector('.swiper-pagination');
    const showNavigation = this.querySelector('.next-button') !== null;
    const slideCount = this.querySelectorAll('.swiper-slide').length;

    const modules = [Keyboard, Pagination];
    if (showNavigation) modules.push(Navigation);

    this.swiper = new Swiper(swiperContainer, {
      modules,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      loop: slideCount > 2,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: paginationEl,
        type: 'fraction',
        formatFractionCurrent: (number) => number,
        formatFractionTotal: (number) => number,
      },
      navigation: showNavigation
        ? {
            nextEl: '.next-button',
            prevEl: '.prev-button',
          }
        : false,
      on: {
        init: () => swiperContainer.classList.remove('swiper-loading'),
      },
    });
  }
}

customElements.define('campaign-sections-carousel', CampaignSectionsCarousel);
